import { render } from "./NewsForm.vue?vue&type=template&id=3e949c67"
import script from "./NewsForm.vue?vue&type=script&lang=js"
export * from "./NewsForm.vue?vue&type=script&lang=js"

import "./NewsForm.vue?vue&type=style&index=0&id=3e949c67&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__